export class GetInitialConnectionManagerInfosAction {
    constructor() {
        this.name = 'GetInitialConnectionManagerInfos';
        this.isDeviceAction = false;
    }
}
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoiR2V0SW5pdGlhbENvbm5lY3Rpb25NYW5hZ2VySW5mb3NBY3Rpb24uanMiLCJzb3VyY2VSb290IjoiIiwic291cmNlcyI6WyIuLi8uLi8uLi8uLi8uLi9zcmMvbGliL21vZGVscy9hY3Rpb25zL0dldEluaXRpYWxDb25uZWN0aW9uTWFuYWdlckluZm9zQWN0aW9uLnRzIl0sIm5hbWVzIjpbXSwibWFwcGluZ3MiOiJBQVdBLE1BQU0sT0FBTyxzQ0FBc0M7SUFBbkQ7UUFDa0IsU0FBSSxHQUFHLGtDQUFrQyxDQUFDO1FBQzFDLG1CQUFjLEdBQUcsS0FBSyxDQUFDO0lBQ3pDLENBQUM7Q0FBQSJ9